var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20913_54664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z",
    fill: "#303F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.35 14.009C7.62 13.909 2 15.269 2 17.999V18.999C2 19.549 2.45 19.999 3 19.999H11.54C9.07 17.239 10.31 14.109 10.35 14.009Z",
    fill: "#303F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4301 18.0186C19.9001 17.2186 20.1301 16.2486 19.9101 15.1986C19.5701 13.5586 18.1901 12.2486 16.5301 12.0386C13.9001 11.6986 11.6801 13.9086 12.0301 16.5386C12.2501 18.1986 13.5501 19.5786 15.1901 19.9186C16.2401 20.1386 17.2101 19.9086 18.0101 19.4386L19.8701 21.2986C20.2601 21.6886 20.8901 21.6886 21.2801 21.2986C21.6701 20.9086 21.6701 20.2786 21.2801 19.8886L19.4301 18.0186ZM16.0001 17.9986C14.9001 17.9986 14.0001 17.0986 14.0001 15.9986C14.0001 14.8986 14.9001 13.9986 16.0001 13.9986C17.1001 13.9986 18.0001 14.8986 18.0001 15.9986C18.0001 17.0986 17.1001 17.9986 16.0001 17.9986Z",
    fill: "#303F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20913_54664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonSearch);
export default __webpack_public_path__ + "static/media/person_search.2687d8d537f408ac91da4d28326374d7.svg";
export { ForwardRef as ReactComponent };